import React, { useState, useEffect } from 'react';
import Styles from './CDCProtegido25AvisarSinistro.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import RedButton from '@/components/atoms/RedButton';
import WhiteButton from '@/components/atoms/WhiteButton';
import ModalSeguros from '@/components/molecules/ModalSeguros';

function CDCProtegido25AvisarSinistro() {
  const [showModal, setShowModal] = useState(false);
  const tituloModal = 'Condições gerais';
  const docs = [
    {
      titulo: 'Condições Gerais Seguro Proteção PJ',
      descricao: `Versão 4 - PROCESSO SUSEP NO 15414.902051/2019-00`,
      link: 'pdf/protegido/Condicoes_Gerais_Prestamista_PJ.pdf',
    },
    {
      titulo: 'Condições Gerais do Seguro Prestamista',
      descricao: `Versão 1 - PROCESSO SUSEP NO 15414.631508/2023-64`,
      link: 'pdf/protegido/Condicoes-Gerais-Prestamista-versao-site.pdf',
    },
    // {
    //   titulo: 'Condições Gerais do Seguro AP',
    //   descricao: `Versão V01_052019 - PROCESSO SUSEP NO 15414.901986.2019-61`,
    //   link: 'pdf/protegido/condicoes-gerais-do-seguro-AP-v3.pdf',
    // },
    {
      titulo: 'Manual de Assistência AUTO',
      descricao: `CDC PROTEGIDO - Seguro Proteção Financeira - SPF`,
      link: 'pdf/protegido/Manual_Assistencia_Auto-CDC.pdf',
    },
    {
      titulo: 'Manual de Assistência MOTO',
      descricao: `CDC PROTEGIDO MOTO COM DESEMPREGO - Seguro Proteção Financeira - SPF`,
      link: '/pdf/protegido/Manual_Assistencia_Moto_CDC_protegido_V6.pdf',
    },
    {
      titulo: 'Regras da Capitalização',
      descricao: `PROMOÇÃO SEGUROS CDC (SPF) - REGULAMENTO SORTEIO CAPITALIZAÇÃO`,
      link: 'pdf/protegido/Regulamento Atualizado para o MVP2.pdf',
    },
    {
      titulo: 'Consulte seu número da sorte',
      descricao: `Consulte aqui seus Números da Sorte.`,
      link: 'https://www.santander.com.br/portal/wps/script/templates/GCMRequest.do?page=5495',
    },
  ];
  const linkBaixarTodos = 'pdf/protegido/condicoes-cdc-protegido-0925.zip';

  useEffect(() => {
    if (showModal) {
      document.getElementsByTagName('html')[0].classList.add('scroll-disabled');
    } else {
      document.getElementsByTagName('html')[0].classList.remove('scroll-disabled');
    }
  }, [showModal]);

  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="cdc-avisar-sinistro">
        <ContainerHome24>
          <div className="avisar-sinistro">
            <h2 className="avisar-sinistro-titulo">Preciso avisar um sinistro</h2>
            <div className="avisar-sinistro-texto-botoes">
              <p className="avisar-sinistro-texto">
                Acesse o nosso Portal de Sinistros e comunique o seu sinistro de forma simples e
                online.
              </p>
              <div className="avisar-sinistro-botoes">
                <RedButton href="avisar-sinistro.html" className="btn-avisar-sinistro">
                  Quero avisar sinistro
                </RedButton>
                <WhiteButton href="canais-de-atendimento.html" className="btn-canais-atendimento">
                  Canais de atendimento
                </WhiteButton>
              </div>
            </div>
          </div>
          <div className="informacoes-seguro">
            <h2 className="informacoes-titulo">
              Informações sobre o seu Seguro Prestamista/Acidente Pessoal:
            </h2>
            <div className="informacoes-texto-botao">
              <p className="informacoes-texto">
                Informações válidas somente para clientes que aderiram a contratação ao Seguro
                Prestamista/Acidente Pessoal de acordo com a descrição que consta no Termo de
                Contratação. Ver condições:
              </p>
              <WhiteButton
                onClick={(e) => {
                  e.preventDefault();
                  setShowModal(true);
                }}
                taget="_blank"
                className="btn-ver-condicoes"
              >
                Ver condições
              </WhiteButton>
            </div>
          </div>
        </ContainerHome24>
        {typeof window === 'undefined' ? (
          <></>
        ) : (
          <>
            {width >= 992 && (
              <img
                src="assets/cdc25/bolinhas-sinistro.svg"
                alt=""
                className="img-bolinhas-sinistro"
              />
            )}
          </>
        )}
      </section>
      {showModal && (
        <ModalSeguros
          setShowModal={setShowModal}
          tituloModal={tituloModal}
          docs={docs}
          linkBaixarTodos={linkBaixarTodos}
        />
      )}
      <style jsx>{Styles}</style>
    </>
  );
}

export default CDCProtegido25AvisarSinistro;
